import React, {
  ReactElement,
  Fragment,
} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import {LoadingButton} from "@mui/lab";

export const CancelConfirmDialog = ({
                              clickOnReject,
                              onClose,
                                      loading,
                            }: {
  clickOnReject: () => void;
  onClose: () => void;
  loading: any;
}): ReactElement => {

  return (
    <>
      <Dialog open={true} onClose={onClose}>
        <DialogTitle>Foglalás lemondása</DialogTitle>
        <DialogContent>
          <Typography variant="caption">Biztosan lemondja a foglalást?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Mégse</Button>
          <LoadingButton
            variant="contained"
            color="error"
            onClick={clickOnReject}
            autoFocus
            loading={loading}
          >
            Lemondás
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
